export const BRAND = {
  navy: '#11194F',
  cyan: '#0095C2',
  orange: '#F97316',
} as const;

const SIGLAS = new Set(['LT', 'ML', 'KG', 'GR', 'GRS', 'CC', 'UN', 'KG.', 'LT.', 'GRS.']);

export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      const upper = word.toUpperCase().replace(/\.$/, '');
      if (SIGLAS.has(upper) || SIGLAS.has(word.toUpperCase())) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export const formatPrecio = (n: number) => `$${Math.round(n).toLocaleString('es-CL')}`;

export { clasificarError, type TipoError } from '../../utils/errores';
